import {
  CampaignState,
  CAMPAIGN_STATE_LABEL,
} from '../../types/leadCampaign';

const STATE_STYLE: Record<CampaignState, string> = {
  draft: 'bg-gray-100 text-gray-700 border border-gray-200',
  active: 'bg-green-100 text-green-700 border border-green-200',
  paused: 'bg-amber-100 text-amber-700 border border-amber-200',
  archived: 'bg-slate-200 text-slate-600 border border-slate-300',
};

interface Props {
  state: CampaignState;
  className?: string;
}

export default function LeadCampaignStateBadge({ state, className = '' }: Props) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${STATE_STYLE[state]} ${className}`}
    >
      {CAMPAIGN_STATE_LABEL[state]}
    </span>
  );
}
